module.exports = __webpack_public_path__ + "images/2fd2659.png";